import React from 'react'
import classes from './card.module.scss';

const Card = ({withfavorite, image, imagefull, isfavorite, children, onClick}) =>{
    return (
        <div className={classes.card} onClick={onClick}>
          { image ? <div className={classes.image} style={{ backgroundImage: `url(${image})` }}></div> :null}
          { imagefull ? <img src={`${imagefull}`}  /> :null}
            <div className={classes.inside}>
                {children}
                { withfavorite && !isfavorite ? <button className={classes.favorite} onClick={(event)=>{event.stopPropagation()}}><img alt="" src={ require('../../assets/img/favorite_off.svg')} /></button>:null }
                { withfavorite && isfavorite ? <button className={classes.favorite} onClick={(event)=>{event.stopPropagation()}}><img alt="" src={ require('../../assets/img/favorite_on.svg')} /></button>:null }
                
            </div>
        </div>
    );
}

export { Card } ;